import React from 'react';

/**
 * Field — label-above-control wrapper shared by Input/Select/Date/Textarea.
 * Renders nothing extra when `label` is omitted (bare control).
 */
export default function Field({ label, htmlFor, className = '', children }) {
  if (!label) return children;
  return (
    <label className={`ui-field ${className}`.trim()} htmlFor={htmlFor}>
      <span className="ui-field__label">{label}</span>
      {children}
    </label>
  );
}
